import { Badge } from 'src/components/ui/Badge';
import { PUBLICATION_LABEL, PUBLICATION_TONE, VERDICT_LABEL, VERDICT_TONE } from 'src/lib/tone';
import type { EditorialPublicationInstruction, EditorialVerdict } from 'src/types/editorial';

export function VerdictBadge({ verdict, confidence }: { verdict: EditorialVerdict; confidence?: number }) {
  return (
    <span className="verdict">
      <Badge tone={VERDICT_TONE[verdict]}>{VERDICT_LABEL[verdict]}</Badge>
      {confidence !== undefined && <span className="verdict__confidence">{confidence.toFixed(2)}</span>}
    </span>
  );
}

/**
 * Composition §7: this is the operationally important field. `do_not_publish` and
 * `report_as_dispute` change what the editor does next, so it renders at verdict weight rather
 * than as a footnote.
 */
export function PublicationInstructionBadge({ instruction }: { instruction: EditorialPublicationInstruction }) {
  return <Badge tone={PUBLICATION_TONE[instruction]}>{PUBLICATION_LABEL[instruction]}</Badge>;
}
